<template>
  <div class="main_bg">
    <div class="main_content">
      <div class="main_content_top">
        <div class="section_middle">
          <el-row :gutter="30">
            <el-col :xs="24" :sm="24" :md="14" :lg="14">
              <!-- 校园新闻 -->
              <home-news />
            </el-col>

            <el-col :xs="24" :sm="24" :md="10" :lg="10">
              <!-- 通知公告 -->
              <home-notice />
            </el-col>
          </el-row>

          <el-row :gutter="30">
            <el-col :xs="24" :sm="24" :md="14" :lg="14">
              <!-- 学院视频 -->
              <home-video />
            </el-col>

            <el-col :xs="24" :sm="24" :md="10" :lg="10">
              <!-- 专题栏目 -->
              <home-special />
            </el-col>
          </el-row>
        </div>

        <!-- 学院风采 -->
        <div class="section_bottom collegeView_box">
          <el-row :gutter="20" class="top_row">
            <el-col :span="12" align="left">
              <img class="md" src="@/assets/images/icon_13.png" alt="" />
              <img
                class="hd"
                src="@/assets/images/icon_13.png"
                alt=""
                style="width: 3px; height: 16px; vertical-align: text-bottom"
              />
              <span>学院风采</span>
            </el-col>
            <router-link :to="{ name: '学院介绍', query: { tab: '4' } }">
              <el-col :span="12" class="more hidden-lg-and-up" align="right">
                <img src="@/assets/images/phone/sub_more.png" alt="" />
              </el-col>
            </router-link>

            <router-link :to="{ name: '学院介绍', query: { tab: '4' } }">
              <el-col
                :md="12"
                :xs="12"
                align="right"
                class="desc hidden-md-and-down"
              >
                旖旎风光 恬静怡人
              </el-col>
            </router-link>
          </el-row>
          <home-college-view />
        </div>

        <!-- 校企合作 -->
        <home-coop />
      </div>
    </div>

    <!-- 推荐阅读 -->
    <home-recommend />
  </div>
</template>

<script>
  import HomeCoop from "@/components/home/home_coop.vue"
  import homeRecommend from "@/components/home/home_recommend.vue"
  import homeCollegeView from "@/components/home/home_collegeView.vue"
  import homeNews from "@/components/home/home-news.vue"
  import homeNotice from "@/components/home/home-notice.vue"
  import homeVideo from "@/components/home/home-video.vue"
  import homeSpecial from "@/components/home/home-special.vue"

  // import homeCollegeNews from "@/components/home/home_news.vue"
  // import homeVideo2 from "@/components/home/home_video.vue"

  // import homeCoopSwiper from "@/components/home/home_coopSwiper.vue"
  export default {
    components: {
      HomeCoop,
      homeRecommend,
      homeCollegeView,
      homeNews,
      homeNotice,
      homeVideo,
      homeSpecial
    },
    data() {
      return {}
    },
    mounted() {},
    created() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  .main_bg {
    width: 100%;
    height: 100%;
    /* background-image: url("../assets/images/home_bg.png"); */
  }
  .main_content {
    padding-top: 0px;
    margin-top: 0 !important;
  }
  .main_content_top {
    width: 1440px;
    margin: 0 auto;
  }
  .top_row img {
    vertical-align: bottom;
    margin-right: 10px;
  }
  .top_row img:last-child {
    vertical-align: text-top;
    margin-left: 10px;
  }
  .top_row span {
    font-size: 22px;
    color: #313131;
  }
  .top_row .desc {
    color: #006ff6;
    font-size: 18px;
    text-align: right;
  }
  .section_middle {
    margin-top: 38px;
  }
  .section_bottom {
    margin-top: 38px;
    padding-bottom: 90px;
  }

  .collegeView_box {
    .top_row {
      .md {
        display: inline-block;
      }
      .hd {
        display: none;
      }
    }
  }
  @media (max-width: 1440px) {
    .main_content_top {
      width: 100%;
    }
    .section_bottom {
      padding-bottom: 0px;
    }
  }
  @media (max-width: 1023px) {
    .collegeVideo {
      margin-top: 38px;
    }
    .videoList .video {
      width: 46%;
      height: 42%;
    }
    .video iframe {
      width: 100%;
      height: 100%;
    }
    .videoList {
      height: 980px;
    }
    .main_content_top {
      width: 100%;
    }
    .main_content_top .section_top {
      padding: 0;
      box-shadow: none;
      background: transparent;
      width: 100%;
    }
    .main_bg {
      background-image: none;
    }
    .section_bottom {
      padding-bottom: 0;
      margin-top: 20px;
    }
    .section_middle {
      margin-top: 10px;
    }
  }
  @media (max-width: 768px) {
    .top_row span {
      font-size: 16px;
    }
    .collegeView_box {
      .top_row {
        .md {
          display: none;
        }
        .hd {
          display: inline-block;
        }
      }
    }
  }
</style>
